import { TrendingUp, Zap, PieChart, BarChart3 } from "lucide-react";
import {
  PromptTypeConfig,
  SECTORS,
  SECTOR_DISPLAY_NAMES,
  MARKET_INDICES,
} from "../../types/market-recap";

export const PROMPT_TYPES: PromptTypeConfig[] = [
  {
    id: "stock-ticker-recap",
    name: "Stock Ticker Recap",
    description: "Deep dive on a specific stock's performance",
    icon: TrendingUp,
    variables: [
      {
        name: "ticker",
        type: "ticker",
        label: "Stock Symbol",
        required: true,
        placeholder: "e.g., AAPL, MSFT, GOOGL",
      },
      {
        name: "period",
        type: "period",
        label: "Time Period",
        required: true,
        options: ["day", "week", "month"],
        default: "week",
      },
    ],
    messageTemplate:
      "Create a market recap slide for {ticker} for the past {period}",
  },
  {
    id: "top-movers",
    name: "Top Movers",
    description: "Today's biggest gainers and losers",
    icon: Zap,
    variables: [
      {
        name: "direction",
        type: "direction",
        label: "Show",
        required: true,
        options: ["gainers", "losers", "both"],
        default: "gainers",
      },
      {
        name: "count",
        type: "count",
        label: "Number of Stocks",
        required: true,
        options: ["3", "5", "10"],
        default: "5",
      },
    ],
    messageTemplate:
      "Create a top movers slide showing today's top {count} {direction}",
  },
  {
    id: "sector-spotlight",
    name: "Sector Spotlight",
    description: "Industry-focused performance analysis",
    icon: PieChart,
    variables: [
      {
        name: "sector",
        type: "sector",
        label: "Sector",
        required: true,
        options: SECTORS,
        default: "technology",
      },
      {
        name: "period",
        type: "period",
        label: "Time Period",
        required: true,
        options: ["day", "week", "month"],
        default: "week",
      },
    ],
    messageTemplate:
      "Create a sector spotlight slide for {sector} this {period}",
  },
  {
    id: "index-overview",
    name: "Index Overview",
    description: "Broad market indices summary",
    icon: BarChart3,
    variables: [
      {
        name: "indices",
        type: "indices",
        label: "Market Indices",
        required: true,
        options: MARKET_INDICES,
        default: ["S&P 500", "Nasdaq", "Dow Jones"],
      },
      {
        name: "period",
        type: "period",
        label: "Time Period",
        required: true,
        options: ["day", "week", "month"],
        default: "week",
      },
    ],
    messageTemplate:
      "Create an index overview slide for {indices} for the past {period}",
  },
];

// Helper to get prompt config by id
export function getPromptConfig(id: string): PromptTypeConfig | undefined {
  return PROMPT_TYPES.find((p) => p.id === id);
}

// Helper to get sector display name
export function getSectorDisplayName(sector: string): string {
  return (
    SECTOR_DISPLAY_NAMES[sector as keyof typeof SECTOR_DISPLAY_NAMES] || sector
  );
}
